import gql from 'graphql-tag';
import fragments from '@/services/api/fragments';

const home = gql`
    query Home {
      home {
        banner {
          ...banner
        }
        opening_hours {
          ...openingHours
        }
        news_items {
          ...newsItems
        }
        text_image {
          ...textImage
        }
        slider {
          ...slider
        }
        services {
          ...services
        }
        teasers {
          ...teasers
        }
      }
    }
    ${fragments.banner}
    ${fragments.openingHours}
    ${fragments.textImage}
    ${fragments.slider}
    ${fragments.services}
    ${fragments.teasers}
    ${fragments.newsItems}
`;

const imprint = gql`
    query Imprint {
        imprint {
            text
        }
    }
`;

const privacy = gql`
    query Privacy {
        privacy {
            text
        }
    }
`;

const settings = gql`
    query Settings {
        setting {
            page_title,
            page_description,
            page_tags
        }
    }
`;

const footer = gql`
    query Footer {
        setting {
            footer_aboutus,
            footer_openinghours,
            footer_route,
            copyright
        }
    }
`;

const cookie = gql`
    query Footer {
        setting {
            cookie_notice
        }
    }
`;

const navigation_footer = gql`
    query NavigationFooter {
        navigationCopyrights {
            id,
            title,
            target
        }
    }
`;

const navigation_main = gql`
    query NavigationMain {
        navigationMains {
            id,
            title,
            target
        }
    }
`;

export default {
  settings,
  home,
  imprint,
  privacy,
  footer,
  cookie,
  navigation_main,
  navigation_footer,
};
